// assets/a24-ui-trace.js
/* Optional UI trace logger. Disabled unless trace_ui=1 or local storage enables it. */
(function () {
  'use strict';

  /* ---- UI trace logger (opt-in) ---- */
  var A24UiTrace = (function () {
    var TRACE_KEY = 'a24-ui-trace';
    var seenErrors = {};

    function readStorageEnabled() {
      try {
        return window.localStorage.getItem(TRACE_KEY) === '1';
      } catch (_e) {
        return false;
      }
    }

    function writeStorageEnabled(enabled) {
      try {
        if (enabled) window.localStorage.setItem(TRACE_KEY, '1');
        else window.localStorage.removeItem(TRACE_KEY);
      } catch (_e) {
        /* ignore storage errors */
      }
    }

    function readParamEnabled() {
      try {
        var params = new URLSearchParams(window.location.search || '');
        var value = params.get('trace_ui');
        if (value === '1') {
          writeStorageEnabled(true);
          return true;
        }
        if (value === '0') {
          writeStorageEnabled(false);
          return false;
        }
      } catch (_e) {
        /* ignore URL parsing errors */
      }
      return null;
    }

    function shortText(str) {
      var text = String(str || '').replace(/\s+/g, ' ').trim();
      return text.length > 100 ? text.slice(0, 97) + '...' : text;
    }

    function cssPath(el) {
      if (!el || !el.tagName) return '';
      var cur = el;
      var parts = [];
      var depth = 0;
      while (cur && cur.tagName && depth < 4) {
        var part = cur.tagName.toLowerCase();
        if (cur.id) {
          part += '#' + cur.id;
          parts.unshift(part);
          break;
        }
        if (cur.classList && cur.classList.length) {
          part += '.' + Array.prototype.slice.call(cur.classList, 0, 2).join('.');
        }
        parts.unshift(part);
        cur = cur.parentElement;
        depth += 1;
      }
      return parts.join(' > ');
    }

    function elementInfo(el) {
      if (!el || !el.tagName) return {};
      var info = {
        tag: String(el.tagName || '').toLowerCase(),
        id: el.id || null,
        className: el.className || null,
        name: el.name || null,
        type: el.type || null,
        value: typeof el.value === 'string' ? shortText(el.value) : null,
        checked: typeof el.checked === 'boolean' ? el.checked : null,
        href: el.href || null,
        text: shortText(el.textContent || ''),
        path: cssPath(el)
      };
      return info;
    }

    function isFilterRelated(el) {
      if (!el || !el.closest) return false;
      return Boolean(el.closest(
        '[data-filter], [data-filter-option], [data-filter-value], [data-filter-key], ' +
        '.shop-filter, .shop-filters, .filter-group, .filter-option, .filter-checkbox, ' +
        '.filter-pill, .filter-chip, .collection-filters, .search-filters, ' +
        '[name*="filter"], [id*="filter"], [class*="filter"]'
      ));
    }

    function extractFilterContext(el) {
      if (!el || !el.closest) return null;
      var optionEl = el.closest(
        '[data-filter-option], [data-filter-value], .filter-option, .filter-pill, .filter-chip, label, li, button, a'
      ) || el;
      var inputEl = el.matches('input,select,textarea')
        ? el
        : optionEl.querySelector && optionEl.querySelector('input,select,textarea');
      var groupEl = optionEl.closest(
        '[data-filter-group], .filter-group, .shop-filter-group, .shop-filter-section'
      );
      var groupTitleEl = groupEl && groupEl.querySelector(
        '.filter-group__toggle, .filter-group__title, [data-filter-group-title], legend, h3, h4'
      );

      return {
        option: elementInfo(optionEl),
        input: elementInfo(inputEl),
        group: {
          id: groupEl && groupEl.id ? groupEl.id : null,
          key: groupEl && groupEl.getAttribute ? (groupEl.getAttribute('data-filter-group') || groupEl.getAttribute('data-filter-key')) : null,
          label: shortText(groupTitleEl && groupTitleEl.textContent ? groupTitleEl.textContent : '')
        }
      };
    }

    function createLogger() {
      var paramEnabled = readParamEnabled();
      var enabled = paramEnabled === null ? readStorageEnabled() : paramEnabled;

      function log(eventName, payload) {
        if (!enabled) return;
        var timestamp = new Date().toISOString();
        var data = payload || {};
        try {
          console.groupCollapsed('[A24 TRACE] ' + eventName + ' @ ' + timestamp);
          console.log(data);
          console.groupEnd();
        } catch (_e) {
          console.log('[A24 TRACE]', eventName, timestamp, data);
        }
      }

      function setEnabled(nextEnabled) {
        enabled = Boolean(nextEnabled);
        writeStorageEnabled(enabled);
      }

      return {
        isEnabled: function () { return enabled; },
        setEnabled: setEnabled,
        log: log
      };
    }

    function init(logger) {
      if (!logger.isEnabled()) return;

      logger.log('trace.enabled', {
        href: window.location.href,
        userAgent: navigator.userAgent,
        note: 'Disable with ?trace_ui=0, enable with ?trace_ui=1'
      });

      document.addEventListener('click', function (event) {
        var target = event.target;
        var clickable = target && target.closest ? target.closest('a,button,label,input,[role="button"],[role="option"]') : target;
        logger.log('ui.click', {
          target: elementInfo(target),
          clickable: elementInfo(clickable),
          page: { href: window.location.href, title: document.title }
        });

        if (isFilterRelated(target)) {
          logger.log('ui.filter.click', {
            filter: extractFilterContext(target),
            page: { href: window.location.href }
          });
        }
      }, true);

      document.addEventListener('change', function (event) {
        var target = event.target;
        logger.log('ui.change', {
          target: elementInfo(target),
          page: { href: window.location.href }
        });

        if (isFilterRelated(target)) {
          logger.log('ui.filter.change', {
            filter: extractFilterContext(target),
            page: { href: window.location.href }
          });
        }
      }, true);

      document.addEventListener('input', function (event) {
        var target = event.target;
        if (!target || !target.matches || !target.matches('input,textarea,select')) return;

        logger.log('ui.input', {
          target: elementInfo(target),
          page: { href: window.location.href }
        });

        if (isFilterRelated(target)) {
          logger.log('ui.filter.input', {
            filter: extractFilterContext(target),
            page: { href: window.location.href }
          });
        }
      }, true);

      document.addEventListener('submit', function (event) {
        logger.log('ui.submit', {
          form: elementInfo(event.target),
          page: { href: window.location.href }
        });
      }, true);

      var originalPushState = history.pushState;
      history.pushState = function () {
        var before = window.location.href;
        var result = originalPushState.apply(history, arguments);
        logger.log('page.pushState', {
          from: before,
          to: window.location.href,
          args: Array.prototype.slice.call(arguments)
        });
        return result;
      };

      var originalReplaceState = history.replaceState;
      history.replaceState = function () {
        var before = window.location.href;
        var result = originalReplaceState.apply(history, arguments);
        logger.log('page.replaceState', {
          from: before,
          to: window.location.href,
          args: Array.prototype.slice.call(arguments)
        });
        return result;
      };

      window.addEventListener('popstate', function () {
        logger.log('page.popstate', { href: window.location.href });
      });

      window.addEventListener('hashchange', function (event) {
        logger.log('page.hashchange', {
          oldURL: event.oldURL,
          newURL: event.newURL
        });
      });

      document.addEventListener('search:results-updated', function (event) {
        logger.log('search.results.updated', {
          detail: event && event.detail ? event.detail : null,
          href: window.location.href
        });
      });

      var mutationState = { pending: false, added: 0, removed: 0, attributes: 0 };
      function flushMutations() {
        mutationState.pending = false;
        logger.log('dom.mutation', {
          addedNodes: mutationState.added,
          removedNodes: mutationState.removed,
          attributeChanges: mutationState.attributes,
          href: window.location.href
        });
        mutationState.added = 0;
        mutationState.removed = 0;
        mutationState.attributes = 0;
      }

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList') {
            mutationState.added += mutation.addedNodes ? mutation.addedNodes.length : 0;
            mutationState.removed += mutation.removedNodes ? mutation.removedNodes.length : 0;
          }
          if (mutation.type === 'attributes') mutationState.attributes += 1;
        });

        if (!mutationState.pending) {
          mutationState.pending = true;
          setTimeout(flushMutations, 250);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'aria-expanded', 'aria-hidden', 'data-active', 'data-open']
      });

      window.addEventListener('error', function (event) {
        var key = [event.message, event.filename, event.lineno, event.colno].join('|');
        if (seenErrors[key]) return;
        seenErrors[key] = true;
        logger.log('js.error', {
          message: event.message,
          filename: event.filename,
          lineno: event.lineno,
          colno: event.colno,
          stack: event.error && event.error.stack ? event.error.stack : null
        });
      });

      window.addEventListener('unhandledrejection', function (event) {
        logger.log('js.unhandledrejection', {
          reason: event && event.reason ? String(event.reason) : null,
          stack: event && event.reason && event.reason.stack ? event.reason.stack : null
        });
      });
    }

    var logger = createLogger();
    init(logger);
    return logger;
  }());

  window.A24UiTrace = A24UiTrace;
}());
